import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Footer from './Footer';

const Layout = () => (
  <div className="min-h-screen flex flex-col bg-[var(--bg-primary)]">
    <Sidebar />
    <main className="flex-1 min-w-0 mt-[52px] sm:ml-[220px]">
      <Outlet />
    </main>
    <div className="sm:ml-[220px]">
      <Footer />
    </div>
  </div>
);

export default Layout;
